import { useMemo } from 'react';

import { LATEST } from 'apps/web_forms/utils/constants';
import { getQualifiedResourceId } from 'apps/web_forms/utils/resourcesUtils';
import useGlobalSelector from 'apps/web_forms/hooks/useGlobalSelector';

/**
 * @typedef {Object} ResourceVersionAndQualifiedId
 * @property {string | number} resourceVersion
 * @property {string} qualifiedResourceId
 */

/**
 * @param {string} resourceIdentifier
 * @returns {ResourceVersionAndQualifiedId}
 */
const useResourceVersion = (resourceIdentifier) => {
  const { resourceVersions } = useGlobalSelector();
  const resourceVersion = useMemo(
    () => resourceVersions?.[resourceIdentifier] || LATEST,
    [resourceVersions, resourceIdentifier]
  );
  const qualifiedResourceId = resourceIdentifier
    ? getQualifiedResourceId(resourceIdentifier, resourceVersion)
    : undefined;

  return {
    resourceVersion,
    qualifiedResourceId,
  };
};

export { useResourceVersion };
export default useResourceVersion;
